import { Modal } from '@trackman/web-shared-components';
import React from 'react';
import { ReactComponent as SettingsIcon } from 'images/TopBar/settingsIcon.svg';
import { Content, TextWithIcon } from './UmpirePlaceholderModalStyles';
import { IconWrapper } from '../Controls/ControlsStyles';

interface IProps {
  onConfirmCallback: () => void;
  onDismissCallback: () => void;
  open: boolean;
}

const UmpirePlaceholderModal: React.FC<IProps> = (props) => {
  const { onConfirmCallback, onDismissCallback, open } = props;

  return (
    <Modal
      open={open}
      onClose={onDismissCallback}
      confirmBtn={{
        onClick: onConfirmCallback,
        label: 'Go to settings',
      }}
      cancelBtn={{
        onClick: onDismissCallback,
      }}
      title='Replace Placeholder umpire'
      maxWidth={'sm'}
      fullWidth
      titleCenter
    >
      <Content>
        <div>This session has a placeholder umpire created by the tagger.</div>
        <TextWithIcon>
          <div>To link the session to an official umpire go to: Settings and CSV import </div>
          <IconWrapper>
            <SettingsIcon />
          </IconWrapper>
        </TextWithIcon>
      </Content>
    </Modal>
  );
};

export default UmpirePlaceholderModal;
